function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else obj[key] = value;
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) {
        return Array.from(iter);
    }
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys, key, i;
    if (typeof Reflect !== "undefined" && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_array(arr) {
    return _array_with_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { twMerge } from '@stereoagency/tailwind-config';
import React, { forwardRef } from 'react';
function $Button(_0, _1) {
    var _ref = [
        _0,
        _1
    ], _ref1 = _to_array(_ref), _ref2 = _ref1[0], _rest = _ref1.slice(1), _ref_type = _ref2.type, type = _ref_type === void 0 ? 'no-icon' : _ref_type, _ref_variant = _ref2.variant, variant = _ref_variant === void 0 ? 'primary' : _ref_variant, icon = _ref2.icon, label = _ref2.label, children = _ref2.children, className = _ref2.className, _ref_htmlType = _ref2.htmlType, htmlType = _ref_htmlType === void 0 ? 'button' : _ref_htmlType, props = _object_without_properties(_ref2, [
        "type",
        "variant",
        "icon",
        "label",
        "children",
        "className",
        "htmlType"
    ]), _rest1 = _sliced_to_array(_rest, 1), ref = _rest1[0];
    return /*#__PURE__*/ React.createElement("button", _object_spread({
        // eslint-disable-next-line
        type: htmlType,
        ref: ref,
        className: twMerge('isolate relative flex justify-center items-center font-semibold font-heading rounded-full border text-button-base transition-all', 'disabled:pointer-events-none disabled:opacity-50', 'focus:outline focus:outline-4 focus:outline-fg-base', type === 'icon-only' && 'p-4', type !== 'icon-only' && 'py-4 px-6', variant === 'primary' && 'bg-button-main-bg-base border-button-main-bg-base text-button-main-fg-base hover:bg-button-main-bg-hover hover:border-button-main-bg-hover', variant === 'secondary' && 'bg-button-secondary-bg-base border-button-secondary-bg-base text-button-secondary-fg-base hover:bg-button-secondary-bg-hover hover:border-button-secondary-bg-hover', variant === 'border' && 'border border-button-bordered-border-base text-button-bordered-fg-base hover:border-button-bordered-border-hover', variant === 'ghost' && 'px-4 py-4 border-transparent text-button-ghost-fg-base hover:text-button-ghost-fg-hover', variant === 'link' && 'px-0 py-0 border-transparent text-button-ghost-fg-base hover:text-button-ghost-fg-hover', className)
    }, props), !!((children || label) && type !== 'icon-only') && /*#__PURE__*/ React.createElement("span", null, children || label), !!(icon && type !== 'no-icon') && /*#__PURE__*/ React.createElement("span", {
        className: twMerge('[&>svg]:block [&>svg]:w-[1.1rem] [&>svg]:h-auto', type === 'icon-before' && '-order-1 mr-3', type === 'icon-after' && 'ml-3')
    }, icon));
}
var Button = /*#__PURE__*/ forwardRef($Button);
export default Button;

//# sourceMappingURL=Button.js.map